var _line, _path, _rect, _line2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMutedMicrophoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 518,
    height: 518,
    viewBox: "0 0 518 518",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 263.374,
    y1: 501.503,
    x2: 263.374,
    y2: 421.967,
    stroke: "#2C2C2C",
    strokeWidth: 32,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.27 246C114.046 299.5 140.446 342 154.27 356.5C168.095 371 209.564 406 260.27 406C310.977 406 355.546 379.5 374.27 356.5C392.995 333.5 411.046 294.5 409.27 246",
    stroke: "#2C2C2C",
    strokeWidth: 32,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 183.046,
    y: 22,
    width: 160,
    height: 320,
    rx: 74,
    stroke: "#2C2C2C",
    strokeWidth: 32
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 506.586,
    x2: 506.586,
    y2: 7.99999,
    stroke: "#FF3B30",
    strokeWidth: 16,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutedMicrophoneIcon);
export default __webpack_public_path__ + "static/media/muted-microphone-icon.728c23bea91f69945cfdf7ef272ec3f6.svg";
export { ForwardRef as ReactComponent };